// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".param-ctn .textinput-ctn.color-field input.value {\n  width: 50%;\n  float: left;\n}\n", ""]);
// Exports
module.exports = exports;
